<script>
  import { createEventDispatcher } from "svelte";
  import Button from "$lib/components/Button.svelte";

  export let numOfItems;
  export let collapsedButtonText;
  export let expandedButtonText;
  export let identifier = "";

  $: itemsAreCollapsed = numOfItems === 4;
  $: seeMoreButtonIcon = itemsAreCollapsed ? "chevron-down" : "chevron-up";
  $: seeMoreButtonText = itemsAreCollapsed ? collapsedButtonText : expandedButtonText;
  $: buttonId = identifier ? `see-${itemsAreCollapsed ? "more" : "less"}-${identifier}` : null;

  const dispatch = createEventDispatcher();

  function setCollapsedState() {
    itemsAreCollapsed = !itemsAreCollapsed;
    let page = !itemsAreCollapsed ? 2 : 1;
    dispatch("navigate", {
      page
    });
  }
</script>

<div class="embedded-content">
  <Button
    variant="ghost"
    size="small"
    class="text-size-14 mx-auto mt-40"
    on:click={setCollapsedState}
    testid="btn-IplSeeMoreSeeLess"
    aria-label={seeMoreButtonText}
    icon={{ trailing: true, type: seeMoreButtonIcon }}
    id={buttonId}
  >
    <span class="inline-flex justify-center place-items-center gap-2">{seeMoreButtonText}</span>
  </Button>
</div>
